import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PhysicianConsultationTab from "../Components/PhysicianConsultationTab";
import { userpatient } from "../Constant/Index";

const PhysicianConsultationDetail = () => {
	const [files, setFiles] = useState([]);

	const handleFileChange = (e) => {
		const newFiles = [...files];
		newFiles[parseInt(e.target.id.split("-").pop(), 10) - 1] =
			e.target.files[0];
		setFiles(newFiles);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(files); // Replace with your form submission logic
	};

	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PhysicianProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex align-items-center  justify-content-between w-100">
										<h5 class="main-heading level-6 ps-3 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											My Consultations
										</h5>
										<PhysicianConsultationTab />
									</div>
								</div>
								<div className="row">
									<div class="col-lg-12">
										<div class="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img src={userpatient} className="img-fluid" alt="" />
												<div>
													<h4 class="main-heading-font level-6 ">John Doe</h4>
													<h5 class="primary-medium-font level-8 extra-color-15">
														Patient
													</h5>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="row  pt-4   pb-4">
									<div class="col-lg-12">
										<div class="order-detail-content">
											<div class="row">
												<div class="col-lg-12">
													<div class="details-pharmacy">
														<h4 class="main-heading-font level-6 ">Symptoms</h4>
														<h5 class="primary-medium-font level-8 extra-color-10">
															Allergy
														</h5>
													</div>
												</div>
												<div class="col-lg-12 mt-3">
													<div class="details-pharmacy">
														<h4 class="main-heading-font level-6 ">Details</h4>
														<h5 class="primary-medium-font level-8 extra-color-10">
															Nullam iaculis metus nec mauris egestas convallis.
															Praesent sit amet urna libero. Aliquam efficitur
															gravida dui, vel accumsan massa vehicula ut.
															Aliquam felis.
														</h5>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<form onSubmit={handleSubmit}>
									<div className="row input-file-wrapper">
										<div className="form-group col-lg-12">
											<div className="position-relative">
												<div className="form-group col-lg-12">
													<div className="pdf-icon">
														<i class="fa-solid fa-file-pdf"></i>
													</div>
													<input
														type="file"
														accept="application/pdf"
														onChange={handleFileChange}
														className="form-control"
													/>
													<div className="icon-input">
														<h4>
															{" "}
															<Link className="download" to="/">
																{" "}
																Download{" "}
															</Link>
														</h4>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="row input-file-wrapper">
										<div className="form-group col-lg-12">
											<div className="position-relative">
												<div className="form-group col-lg-12">
													<div className="pdf-icon">
														<i class="fa-solid fa-file-pdf"></i>
													</div>
													<input
														type="file"
														accept="application/pdf"
														onChange={handleFileChange}
														className="form-control"
													/>
													<div className="icon-input">
														<h4>
															{" "}
															<Link className="download" to="/">
																{" "}
																Download{" "}
															</Link>
														</h4>
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>
								<div class="row mt-3 border-top pt-4">
									<div className="col-lg-12">
										<Link
											class="detail-physician-btn calender-bg extra-bg-14 w-100 d-flex align-items-center justify-content-center"
											href="/consultation-detail"
										>
											<span>
												<i class="fa-regular fa-calendar"></i>{" "}
											</span>
											Sun - May 10, 1:00pm - 2:00pm
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianConsultationDetail;
